import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
var CardSubtitle = function (props) {
    return (React.createElement("div", { style: props.style, className: classNames('k-card-subtitle', props.className) }, props.children));
};
CardSubtitle.propTypes = {
    className: PropTypes.string
};
export default CardSubtitle;
//# sourceMappingURL=CardSubtitle.js.map